var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 36,
    viewBox: "0 0 50 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m43.11551,0H6.88449C3.08843,0,0,2.99099,0,6.66736v22.66521c0,3.67637,3.08843,6.66743,6.88449,6.66743h36.23103c3.79606,0,6.88449-2.99106,6.88449-6.66743V6.66736c0-3.67637-3.08843-6.66736-6.88449-6.66736Zm3.82325,29.33257c0,2.04169-1.71509,3.70271-3.82325,3.70271H6.88449c-2.10816,0-3.82325-1.66102-3.82325-3.70271V6.66736c0-2.04162,1.71509-3.70264,3.82325-3.70264h36.23103c2.10816,0,3.82325,1.66102,3.82325,3.70264v22.66521Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.59158,8.38363l-15.5714,11.2631-15.55219-11.26255c-.67707-.4903-1.63617-.35644-2.1425.29942-.50619.65565-.36769,1.58465.30924,2.07488l16.46827,11.92594c.27181.19678.59422.29521.91663.29521.32213,0,.64426-.09822.91593-.29467l16.48789-11.92594c.67721-.48989.81626-1.41876.31036-2.07475-.50577-.65599-1.46501-.79032-2.14222-.30064Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMessage);
export default __webpack_public_path__ + "static/media/direct-message.770ff88ded28bb7e5008c6694c8025a6.svg";
export { ForwardRef as ReactComponent };